import { render } from "./CloseIcon.vue?vue&type=template&id=4c388471"
const script = {}
script.render = render

export default script